module.exports = __webpack_public_path__ + "static/img/tenderInfoBg.7f9cff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenderInfoBg.png
// module id = cTUz
// module chunks = 0